// extracted by mini-css-extract-plugin
export default {"content":"aTjUQXEjnofLYebTg89Q"};